// Base colors
export const colors = {
  black: "rgba(0,0,0,1.00)",
  blackOLED: "rgba(23,23,23,1.00)",
  blue: "#062072",
  brown: "#4D3607",
  deepBlue: "#0044A4",
  green10: "rgba(2,44,19,1.00)",
  green20: "rgba(3,63,27,1.00)",
  green30: "rgba(5,81,35,1.00)",
  green40: "rgba(6,100,44,1.00)",
  green50: "rgba(8,118,52,1.00)",
  green60: "rgba(9,137,60,1.00)",
  green70: "rgba(54,161,96,1.00)",
  green80: "rgba(99,184,133,1.00)",
  green90: "rgba(143,208,169,1.00)",
  green95: "rgba(188,231,206,1.00)",
  green99: "rgba(224,249,234,1.00)",
  grey10: "rgba(39,34,43,1.00)",
  grey20: "rgba(56,50,60,1.00)",
  grey30: "rgba(73,66,78,1.00)",
  grey40: "rgba(89,82,95,1.00)",
  grey50: "rgba(106,98,113,1.00)",
  grey60: "rgba(123,114,130,1.00)",
  grey70: "rgba(147,140,153,1.00)",
  grey80: "rgba(171,164,176,1.00)",
  grey90: "rgba(197,189,201,1.00)",
  grey95: "rgba(220,216,223,1.00)",
  grey99: "rgba(244,242,245,1.00)",
  lightBlue: "#1963CC",
  purple10: "rgba(54,8,94,1.00)",
  purple20: "rgba(74,21,121,1.00)",
  purple30: "rgba(95,35,147,1.00)",
  purple40: "rgba(115,48,174,1.00)",
  purple50: "rgba(136,62,200,1.00)",
  purple60: "rgba(156,75,227,1.00)",
  purple70: "rgba(174,108,233,1.00)",
  purple80: "rgba(193,141,238,1.00)",
  purple90: "rgba(211,174,244,1.00)",
  purple95: "rgba(230,207,249,1.00)",
  purple99: "rgba(248,240,255,1.00)",
  red10: "rgba(77,13,10,1.00)",
  red20: "rgba(106,21,17,1.00)",
  red30: "rgba(134,30,24,1.00)",
  red40: "rgba(163,38,31,1.00)",
  red50: "rgba(191,58,38,1.00)",
  red60: "rgba(220,55,45,1.00)",
  red70: "rgba(228,102,93,1.00)",
  red80: "rgba(234,129,122,1.00)",
  red90: "rgba(241,165,161,1.00)",
  red95: "rgba(248,202,199,1.00)",
  red99: "rgba(255,240,239,1.00)",
  transparent: "transparent",
  white: "rgba(255,255,255,1.00)",
  yellow: "#E6A306",
};

// Shades
export const shades = {
  shade5: "rgba(0,0,0,0.05)",
  shade10: "rgba(0,0,0,0.10)",
  shade15: "rgba(0,0,0,0.15)",
  shade20: "rgba(0,0,0,0.20)",
  shade25: "rgba(0,0,0,0.25)",
  shade30: "rgba(0,0,0,0.30)",
  shade40: "rgba(0,0,0,0.40)",
  shade50: "rgba(0,0,0,0.50)",
  shade60: "rgba(0,0,0,0.60)",
  shade70: "rgba(0,0,0,0.70)",
  shade80: "rgba(0,0,0,0.80)",
  shade90: "rgba(0,0,0,0.90)",
};

// Tints
export const tints = {
  tint5: "rgba(255,255,255,0.05)",
  tint10: "rgba(255,255,255,0.10)",
  tint15: "rgba(255,255,255,0.15)",
  tint20: "rgba(255,255,255,0.20)",
  tint30: "rgba(255,255,255,0.30)",
  tint40: "rgba(255,255,255,0.40)",
  tint50: "rgba(255,255,255,0.50)",
  tint60: "rgba(255,255,255,0.60)",
  tint70: "rgba(255,255,255,0.70)",
  tint80: "rgba(255,255,255,0.80)",
  tint90: "rgba(255,255,255,0.90)",
};

// Constant semantic colors (not theme-dependent)
export const constantSemanticColors = {
  onOverlayDarkBackground: colors.grey20,
  onOverlayDarkHighest: colors.white,
  onOverlayDarkMedHigh: colors.grey99,
  onOverlayDarkMed: colors.grey80,
  onOverlayDarkMedLow: colors.grey50,
  onOverlayDarkLow: colors.grey30,
  onOverlayDarkLowest: colors.grey20,
  onColorHighest: colors.white,
  onColorVeryHigh: tints.tint60,
  onColorHigh: tints.tint30,
  onColorMedHigh: tints.tint10,
  onColorMedLow: shades.shade10,
  onColorLow: shades.shade30,
  onColorVeryLow: shades.shade60,
  onColorLowest: colors.black,
  fixedLightenHighest: tints.tint90,
  fixedLightenVeryHigh: tints.tint80,
  fixedLightenHigher: tints.tint70,
  fixedLightenHigh: tints.tint60,
  fixedLightenMedHigh: tints.tint50,
  fixedLightenMed: tints.tint40,
  fixedLightenMedLow: tints.tint30,
  fixedLightenLow: tints.tint20,
  fixedLightenLower: tints.tint15,
  fixedLightenVeryLow: tints.tint10,
  fixedLightenLowest: tints.tint5,
  fixedDarkenHighest: shades.shade90,
  fixedDarkenVeryHigh: shades.shade80,
  fixedDarkenHigher: shades.shade70,
  fixedDarkenHigh: shades.shade60,
  fixedDarkenMedHigh: shades.shade50,
  fixedDarkenMed: shades.shade40,
  fixedDarkenMedLow: shades.shade30,
  fixedDarkenLow: shades.shade20,
  fixedDarkenLower: shades.shade15,
  fixedDarkenVeryLow: shades.shade10,
  fixedDarkenLowest: shades.shade5,
};
